import React, { useRef } from 'react';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import PrintModal from 'components/common/Modals/PrintModal';
import PageViewer from 'components/common/PageViewer';
import PageForPrint from 'components/common/PageForPrint';
import type { Book } from '@monorepo/shared/src/graph/schema-generated-types-student';

const t = (key, options?) => translate('activities', key, { ...options });

type Props = {
  book: Book;
  afterPrint: () => void;
  onClose: () => void;
};

const PrintPageModal = ({ book, afterPrint, onClose }: Props) => {
  const refToPrint = useRef();

  return (
    <>
      <PrintModal
        afterPrint={afterPrint}
        onClose={onClose}
        text={t('printPage')}
        refToPrint={refToPrint}
      >
        <PageViewer book={book} pages={book.pages} />
      </PrintModal>
      {book.pages?.length && (
        <PageForPrint pdfUrl={book.url} pages={book.pages} printRef={refToPrint} />
      )}
    </>
  );
};

export default PrintPageModal;
